module.exports = __webpack_public_path__ + "static/img/score-mobile-1.dce56b60.png";